var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreen24PxRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fullscreen_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/fullscreen_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57143 8.14286C5.57143 8.85 4.99286 9.42857 4.28571 9.42857C3.57857 9.42857 3 8.85 3 8.14286V4.28571C3 3.57857 3.57857 3 4.28571 3H8.14286C8.85 3 9.42857 3.57857 9.42857 4.28571C9.42857 4.99286 8.85 5.57143 8.14286 5.57143H5.57143V8.14286ZM3 15.8571C3 15.1499 3.57857 14.5714 4.28571 14.5714C4.99286 14.5714 5.57143 15.1499 5.57143 15.8571V18.4285H8.14286C8.85 18.4285 9.42857 19.0071 9.42857 19.7142C9.42857 20.4214 8.85 20.9999 8.14286 20.9999H4.28571C3.57857 20.9999 3 20.4214 3 19.7142V15.8571ZM18.4285 18.4285H15.8571C15.1499 18.4285 14.5714 19.0071 14.5714 19.7142C14.5714 20.4214 15.1499 20.9999 15.8571 20.9999H19.7142C20.4214 20.9999 20.9999 20.4214 20.9999 19.7142V15.8571C20.9999 15.1499 20.4214 14.5714 19.7142 14.5714C19.0071 14.5714 18.4285 15.1499 18.4285 15.8571V18.4285ZM15.8571 5.57143C15.1499 5.57143 14.5714 4.99286 14.5714 4.28571C14.5714 3.57857 15.1499 3 15.8571 3H19.7142C20.4214 3 20.9999 3.57857 20.9999 4.28571V8.14286C20.9999 8.85 20.4214 9.42857 19.7142 9.42857C19.0071 9.42857 18.4285 8.85 18.4285 8.14286V5.57143H15.8571Z",
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen24PxRounded);
export default __webpack_public_path__ + "static/media/fullscreen_24px_rounded.11b0c402.svg";
export { ForwardRef as ReactComponent };